(function () {
    'use strict';

    angular
        .module('app')
        .factory('SystemSettingsService', SystemSettingsService);

    SystemSettingsService.$inject = ['DataService'];

    function SystemSettingsService(DataService) {
        return DataService('systemsetting');
    }
})();